// Попап логина

import basePopup from "./base-popup";
import ajaxForm from "../../components/ajax-form";
import formGroup from "../../components/form-group";

const template = /* html */`
    <transition name="fade">
        <base-popup id="signin-popup" show-logo v-cloak :isActive="isActive" v-show="isActive">
            <template #header>
                <div class="popup__header-text signup-link">
                    Войдите или <a href="#registration_popup" data-source="SIGNIN"
                        class="js-show-popup">зарегистрируйтесь</a>
                </div>
            </template>
            <ajax-form
                id="login-form"
                action="/profile/ajax-login/"
                submit-text="Войти в систему"
                submit-class="popup__button"
                autocomplete="off"
                :reach-goal-on-success="{goalName: 'LOGGED_IN'}"
                #default="props"
                :shouldClearErrors="!isActive"
            >
                <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken">
                <input
                    class="js_next_field"
                    type="hidden"
                    name="next"
                    :value="nextPage"
                >
                <form-group
                    label="Почта"
                    :errors="props.errors.email"
                    input-type="email"
                    form-name="login"
                    input-class="js-popup-email"
                    :value="email"
                    :is-focused="true"
                    @input-changed="$emit('emailChanged', $event)"
                >
                </form-group>
                <form-group
                    label="Пароль"
                    :errors="props.errors.password"
                    input-type="password"
                    form-name="login"
                >
                </form-group>
                <div class="form-group">
                    <div class="frow">
                        <div class="col-xs-12 col-sm-6">
                            <div class="left-icheckbox">
                                <input
                                    type="checkbox"
                                    name="login-remember_me"
                                    class="icheckbox"
                                    id="id_remember_me"
                                >
                            </div>
                            <label for="id_remember_me"> Запомнить меня</label>
                        </div>
                        <div class="col-xs-12 col-sm-6 popup__reset-link">
                            <a
                                id="password_reset"
                                href="#password_reset_popup"
                                class="js-show-popup"
                                >
                                Забыли пароль?
                            </a>
                        </div>
                    </div>
                </div>
            </ajax-form>
        </base-popup>
    </transition>
`;

export default {
    props: {
        nextPage: {
            type: String,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
        email: { type: String },
        isActive: { type: Boolean },
    },
    template,
    components: {
        basePopup,
        ajaxForm,
        formGroup,
    },
    emits: ["emailChanged"],
    name: "SigninPopup",
};
